import React, { useState, useEffect } from "react";
import  BreadcrumbPage  from "../Common/CommonSections/Breadcrum";
import BannerComponent from "./AbouMaadBanner";
import AboutMaadDetailsComponent from "./AboutMaadDetails";
import AboutMaadaddressComponent from "./AboutMaadaddress"
import { getAboutMayoGallery } from "../../services/routes.services";

const AbouMaadRoute = () =>{
    const [gallery, setGallery] = useState([]);
    useEffect(()=>{
        getAboutMayoGallery().then((res) => {
            setGallery(res.data.maad)
        })
        .catch(error => {
            console.log(error);
        })
    }, [])
    return(
        <div>
            <BreadcrumbPage home="Home" listOne="About MAAD"/>
            <BannerComponent SliderImage={gallery} />
            <AboutMaadDetailsComponent/>
            <AboutMaadaddressComponent/>
         
        </div>
    )
}

export default AbouMaadRoute;